import './SessionTimeoutWarning.css';

interface Props {
  secondsLeft: number;
  onStayActive: () => void;
}

export default function SessionTimeoutWarning({ secondsLeft, onStayActive }: Props) {
  const mins = Math.floor(secondsLeft / 60);
  const secs = secondsLeft % 60;
  const countdown = `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;

  return (
    <div
      className="st-backdrop"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="st-title"
      aria-describedby="st-desc"
    >
      <div className="st-modal">
        <div className="st-icon" aria-hidden="true">&#9201;</div>

        <h2 id="st-title" className="st-title">Session About to Expire</h2>

        <p id="st-desc" className="st-message">
          You have been inactive for almost 30 minutes.          
        </p>
        <p id="st-desc" className="st-message">
          You will be automatically logged out in  <br/>
          {countdown} 
        </p>
        {/* <div className="st-countdown" aria-live="off">
          {countdown}
        </div> */}

        <p className="st-sub">
          Click below to continue your session.
        </p>

        <button
          className="st-btn"
          onClick={onStayActive}
          autoFocus
          type="button"
        >
          Stay Active
        </button>
      </div>
    </div>
  );
}
